/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LexplusUploadIdsDto } from '../../models/lexplus-upload-ids-dto';

export interface UploadsControllerBulkDownloadV1$Params {
      body: LexplusUploadIdsDto
}

export function uploadsControllerBulkDownloadV1(http: HttpClient, rootUrl: string, params: UploadsControllerBulkDownloadV1$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
  const rb = new RequestBuilder(rootUrl, uploadsControllerBulkDownloadV1.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'blob', accept: 'application/zip', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Blob>;
    })
  );
}

uploadsControllerBulkDownloadV1.PATH = '/v1/uploads/bulk-download';
